import React from 'react'
import Manager from '../../public/components/Manager'
import FlowRecordDetail from './FlowRecordDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        { icon: 'plus', text: '添加 ...', handler: ({ showDetail }) => showDetail(props => <FlowRecordDetail {...props} id={0} processId={1} />) },
      ],
    columns: [
        { _text: '编号', minWidth: 150, locked: false, flex: 2, search: true },
        { _text: '流程名称', minWidth: 150, flex: 2, filter: true },
        { _text: '标题', minWidth: 150, flex: 2, filter: true },
        { _text: '状态', minWidth: 150, flex: 2, filter: true },
        { _: 'RelevantPerson', field: 'RelevantPerson', search: true },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <FlowRecordDetail {...props} id={data.id} />)
    }
}

export default props => <Manager {...props} config={config} />